import React from 'react';
import Image from 'next/image';
import { cn } from '@/lib/twUtils';

export interface QuoteAvatarProps {
  /** Foto quadrata del professionista o logo dello studio */
  image?: string;
  /** Iniziali mostrate nel cerchio quando la foto non c'è */
  initials: string;
  /** Su banda scura il cerchio delle iniziali si schiarisce */
  onDark?: boolean;
  /** Per cambiare il diametro (default 44px) */
  className?: string;
}

/**
 * Il cerchio accanto a chi firma una citazione: la foto, o le iniziali quando
 * non c'è. In entrambi i casi è decorativo: il nome è già scritto lì accanto e
 * non va riletto dallo screen reader.
 */
const QuoteAvatar = ({ image, initials, onDark = false, className }: QuoteAvatarProps) =>
  image ? (
    <Image
      src={image}
      alt=""
      width={44}
      height={44}
      className={cn('h-11 w-11 shrink-0 rounded-full object-cover', className)}
    />
  ) : (
    <span
      aria-hidden
      className={cn(
        'grid h-11 w-11 shrink-0 place-items-center rounded-full text-[0.8125rem] font-semibold',
        onDark ? 'bg-white/20 text-white' : 'bg-mist-deep text-primary',
        className
      )}
    >
      {initials}
    </span>
  );

export default QuoteAvatar;
